var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.53571C4 3.23985 4.22386 3 4.5 3H16.5C16.7761 3 17 3.23985 17 3.53571V5.67857C17 5.81091 16.9543 5.93857 16.8716 6.03694L12.5 11.2413V16.3929C12.5 16.6234 12.3623 16.8282 12.1581 16.9011L9.15811 17.9725C9.00564 18.027 8.83803 17.9996 8.70764 17.8989C8.57726 17.7982 8.5 17.6365 8.5 17.4643V11.2413L4.12835 6.03694C4.04572 5.93857 4 5.81091 4 5.67857V3.53571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b118532d4af899787fcc0129a79a7ea5.svg";
export { ForwardRef as ReactComponent };